import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 add_tenant_sales_rep: { message: "idle" },
};

export const add_tenant_sales_rep_Slice = createSlice({
 name: "add_tenant_sales_rep",
 initialState,
 reducers: {
  success_add_tenant_sales_rep: (state, action) => {
   state.add_tenant_sales_rep = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_add_tenant_sales_rep: (state, action) => {
   state.add_tenant_sales_rep = { status: app_consts.FAIL, message: action.payload };
  },
  reset_add_tenant_sales_rep: (state) => {
   state.add_tenant_sales_rep = { status: app_consts.IDLE };
  },
  loading_add_tenant_sales_rep: (state) => {
   state.add_tenant_sales_rep = { status: app_consts.LOADING };
  },
 }
});

export const { success_add_tenant_sales_rep, fail_add_tenant_sales_rep, reset_add_tenant_sales_rep, loading_add_tenant_sales_rep } = add_tenant_sales_rep_Slice.actions;

export default add_tenant_sales_rep_Slice.reducer;